import React from 'react';

let idCounter = 0;

export default function FormField({ label, error, children, htmlFor }) {
  const generatedId = React.useMemo(() => `field-${(idCounter += 1)}`, []);
  const id = htmlFor || generatedId;
  const child = React.cloneElement(children, {
    id,
    'aria-describedby': error ? `${id}-error` : undefined,
    'aria-invalid': error ? 'true' : undefined,
  });

  return (
    <div style={{ marginBottom: 'var(--space-4)' }}>
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: 'var(--font-size-sm)',
          fontWeight: 600,
          color: 'var(--color-text-secondary)',
          marginBottom: 'var(--space-1)',
        }}
      >
        {label}
      </label>
      {child}
      {error && (
        <p
          id={`${id}-error`}
          role="alert"
          style={{
            color: 'var(--color-danger)',
            fontSize: 'var(--font-size-xs)',
            margin: '4px 0 0',
          }}
        >
          {error}
        </p>
      )}
    </div>
  );
}

export const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  fontFamily: 'var(--font-ui)',
  fontSize: 'var(--font-size-sm)',
  border: '1px solid var(--color-border)',
  borderRadius: 'var(--radius-sm)',
  background: 'var(--color-surface)',
  color: 'var(--color-text-primary)',
  boxSizing: 'border-box',
};
